import './SlideBackground.css'

const SlideBackground = () => {
  return (
    <div className="bg-wrapper h-full w-full">
      <div className="bg"></div>
      <div className="bg bg2"></div>
      <div className="bg bg3"></div>
    </div>
  );
};

export default SlideBackground;
